var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5316 5.53081L6.53157 13.5308C6.4619 13.6007 6.3791 13.6562 6.28794 13.6941C6.19677 13.7319 6.09904 13.7514 6.00032 13.7514C5.90161 13.7514 5.80387 13.7319 5.71271 13.6941C5.62155 13.6562 5.53875 13.6007 5.46907 13.5308L1.96907 10.0308C1.89931 9.96105 1.84397 9.87823 1.80621 9.78707C1.76846 9.69592 1.74902 9.59823 1.74902 9.49956C1.74902 9.4009 1.76846 9.3032 1.80621 9.21205C1.84397 9.1209 1.89931 9.03808 1.96907 8.96831C2.03884 8.89855 2.12166 8.84321 2.21281 8.80545C2.30397 8.76769 2.40166 8.74826 2.50032 8.74826C2.59899 8.74826 2.69668 8.76769 2.78784 8.80545C2.87899 8.84321 2.96181 8.89855 3.03157 8.96831L6.00095 11.9377L13.4703 4.46956C13.6112 4.32867 13.8023 4.24951 14.0016 4.24951C14.2008 4.24951 14.3919 4.32867 14.5328 4.46956C14.6737 4.61046 14.7529 4.80156 14.7529 5.00081C14.7529 5.20007 14.6737 5.39117 14.5328 5.53206L14.5316 5.53081Z",
    fill: "#985AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCheckIcon);
export default __webpack_public_path__ + "static/media/purpleCheckIcon.85190d1327a31f2518b926c098a267d3.svg";
export { ForwardRef as ReactComponent };